import { createContext } from 'react';

type Props = { collect?: (page: string, key: string) => Promise<void> };

const TranslationCollectorContext = createContext<Props>({});

export default TranslationCollectorContext;
